import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class BnTransactionsTableInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.requestHandler(request));
  }

  requestHandler(request: HttpRequest<any>): HttpRequest<any> {
    
    if ((request.url.indexOf('transaction-manager/client-api/v2/transactions') > -1 || request.url.indexOf('transaction-manager/client-api/v2/transactions/export') > -1) && request.method === 'GET') {
      const modifiedParams = request.params.set('direction', "DESC").set("orderBy", "creationTime");
      const clonedRequest = request.clone({
        params: modifiedParams
      });

      return clonedRequest;
    }
    return request;
  }
}
